<script>
export default {
    name: "BillReportPrint",

    data() {

        return {
            payments: [],
        };
    },

    mounted() {

        this.fetchReceivedPayments().then(() => {
            window.print();
        }).catch(() => {});
    },

    methods: {

        fetchReceivedPayments() {
            if(!this.$route.query.dateFrom && !this.$route.query.dateTo) return Promise.reject();
            let url = `AccountsReports/GetReceivedPayments?Datefrom=${this.$route.query.dateFrom}&Dateto=${this.$route.query.dateTo}`;
                url += this.$route.query.search ? `&SearchText=${this.$route.query.search}` : ``;
            return this.$http.get(url).then(response => {
                this.payments = response.data;
            }).catch(() => {});
        },
    }
}
</script>
<template>
<div class="flex flex-wrap">
    <div class="w-full text-center my-2">
        <h5 class="font-bold text-base">Payments Againts Bills Report</h5>
    </div>
    <table class="table table-bordered">
        <thead class="text-xs">
              <tr class="w-full flex">
                  <th class="p-tiny w-1/6">Date</th>
                  <th class="p-tiny w-1/6">Patient</th>
                  <th class="p-tiny w-1/6">IPFile No</th>
                  <th class="p-tiny w-1/12">OPFile No</th>
                  <th class="p-tiny w-1/12">Receipt No</th>
                  <th class="p-tiny w-1/12">Mode</th>
                  <th class="p-tiny w-1/12">Paid</th>
                  <th class="p-tiny w-1/12">Reversed</th>
                  <th class="p-tiny w-1/12">Receipt</th>
              </tr>
        </thead>
        <tbody class="text-xs flex flex-col items-center">
            <tr class="w-full flex" v-for="(payment, idx) in payments.billPaymentsReport" :key="idx">
                <td class="p-tiny w-1/6">{{ payment.date | dateFormat }}</td>
                <td class="p-tiny w-1/6">{{ payment.patient }}</td>
                <td class="p-tiny w-1/6">{{ payment.ipfileno }}</td>
                <td class="p-tiny w-1/12">{{ payment.opfileno }}</td>
                <td class="p-tiny w-1/12">{{ payment.receipt_No || `-` }}</td>
                <td class="p-tiny w-1/12">{{ payment.mode }}</td>
                <td class="p-tiny w-1/12">{{ payment.amount | numberFormat }}</td>
                <td class="p-tiny w-1/12">{{ payment.creditAmount | numberFormat }}</td>
                <td class="p-tiny w-1/12">{{ payment.receiptAmount | numberFormat }}</td>
            </tr>
        </tbody>
    </table>
</div>
</template>
